function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import PropTypes from 'prop-types';
import { SelectGroup } from 'module-tsl-ui-elements';
import { Field } from 'formik';

var CustomSelect = function CustomSelect(_ref) {
  var _ref$field = _ref.field,
      name = _ref$field.name,
      value = _ref$field.value,
      onChange = _ref$field.onChange,
      onBlur = _ref$field.onBlur,
      _ref$form = _ref.form,
      touched = _ref$form.touched,
      errors = _ref$form.errors,
      submitCount = _ref$form.submitCount,
      options = _ref.options,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(SelectGroup, {
    self: {
      error: (touched[name] || Boolean(submitCount)) && errors[name]
    },
    select: {
      name: name,
      value: value,
      options: [{
        value: '',
        label: 'Please select'
      }].concat(_toConsumableArray(options)),
      onChange: onChange,
      onBlur: onBlur
    },
    label: {
      text: label
    }
  });
};

CustomSelect.displayName = "CustomSelect";
CustomSelect.propTypes = {
  field: PropTypes.objectOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  })).isRequired,
  form: PropTypes.objectOf(PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.array,
    submitCount: PropTypes.number
  })).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  label: PropTypes.string.isRequired
};

var EnhancedSelect = function EnhancedSelect(props) {
  return /*#__PURE__*/React.createElement(Field, _extends({
    component: CustomSelect
  }, props));
};

EnhancedSelect.displayName = "EnhancedSelect";
export default EnhancedSelect;